import { atom, DefaultValue, selector } from "recoil";
import { recoilPersist } from "recoil-persist";
import { CustomerState } from "./customerState";
import { RealtorState } from "./realtorState";

const { persistAtom } = recoilPersist();
// const { persistAtom } = recoilPersist();

// page1
// // URLで状態を管理するためrecoilでは不要
// export const propertyTypeState = atom<"apartment" | "house" | undefined>({
//   key: "propertyType",
//   default: undefined,
//   // effects_UNSTABLE: [persistAtom],
// });

type IPropertyType = "apartment" | "house" | "";
export const PropertyTypeState = atom<IPropertyType>({
  key: "propertyType",
  default: "",
});
export const propertyNameState = atom({
  key: "propertyName",
  default: "",
});
export const postCodeState = atom({
  key: "postCode",
  default: "",
});
export const locationAreaState = atom({
  key: "locationArea",
  default: "",
});
export const locationDetailState = atom({
  key: "locationDetail",
  default: "",
});
export interface IInputPage1 {
  propertyName: string;
  postCode: string;
  locationArea: string;
  locationDetail: string;
}
export const Page1State = selector<IInputPage1>({
  key: "inputPage1",
  get: ({ get }) => {
    return {
      propertyName: get(propertyNameState),
      postCode: get(postCodeState),
      locationArea: get(locationAreaState),
      locationDetail: get(locationDetailState),
    };
  },
  set: ({ set, reset }, newValue) => {
    if (newValue instanceof DefaultValue) {
      reset(propertyNameState);
      reset(postCodeState);
      reset(locationAreaState);
      reset(locationDetailState);
      return;
    }
    set(propertyNameState, newValue.propertyName);
    set(postCodeState, newValue.postCode);
    set(locationAreaState, newValue.locationArea);
    set(locationDetailState, newValue.locationDetail);
  },
});

// page2
export const buildingYearState = atom({
  key: "buildingYear",
  default: "",
});
export type BuildingStructure =
  | "wood"
  | "light_weight_steel"
  | "reinforced_concrete"
  | "";
export const buildingStructureState = atom<BuildingStructure>({
  key: "buildingStructure",
  default: "",
});
export const livingAreaState = atom({
  key: "livingArea",
  default: "",
});
export const landAreaState = atom({
  key: "landArea",
  default: "",
});
export type LayoutType =
  | "未選択"
  | "ワンルーム"
  | "1K"
  | "1DK/LDK"
  | "2K/DK/LDK"
  | "3K/DK/LDK"
  | "4K/DK/LDK"
  | "5K以上";
export const layoutTypeState = atom<LayoutType>({
  key: "layoutType",
  default: "未選択",
});
export const locatedFloorState = atom({
  key: "locatedFloor",
  default: "",
});
export const totalFloorState = atom({
  key: "totalFloor",
  default: "",
});

// valuation
export interface IValuatingInput {
  deal_types: string[];
  property_type: string;

  address: string;
  building_name: string;
  postcode: string;
  building_year: number;
  living_area: number;

  layout?: string;
  aboveground_floor?: number;
  structure?: string;
  located_floor?: number;
  land_area?: number;

  customer: {
    message: string;
    email: string;
    name: string;
    phone: string;
    consideration: string;
  };
}
export const ValuatingInputState = selector<IValuatingInput>({
  key: "valuatingInput",
  get: ({ get }) => {
    let item: IValuatingInput = {
      deal_types: get(RealtorState).deal_types,
      address: get(locationAreaState) + get(locationDetailState),
      building_name: get(propertyNameState),
      postcode: get(postCodeState),
      property_type: get(PropertyTypeState),
      building_year: Number(get(buildingYearState)),
      living_area: Number(get(livingAreaState)),

      customer: {
        message: get(CustomerState).message,
        email: get(CustomerState).email,
        name: get(CustomerState).name,
        phone: get(CustomerState).phone,
        consideration: get(CustomerState).consideration,
      },
    };

    // 任意の値を選択
    if (get(layoutTypeState) !== "未選択")
      item["layout"] = get(layoutTypeState);
    if (get(buildingStructureState) !== "")
      item["structure"] = get(buildingStructureState);
    if (get(locatedFloorState) !== "")
      item["located_floor"] = Number(get(locatedFloorState));
    if (get(landAreaState) !== "")
      item["land_area"] = Number(get(landAreaState));
    if (get(totalFloorState) !== "")
      item["aboveground_floor"] = Number(get(totalFloorState));

    return item;
  },
});

// result
interface Range {
  lower: number;
  upper: number;
}
interface Option {
  label: string;
  value: number;
}
export interface ValuatedType {
  sale: Range | null;
  rent: Range | null;
  trend: Option[] | null;
}
export const valuatedState = atom<ValuatedType>({
  key: "valuated",
  default: {
    sale: null,
    rent: null,
    trend: null,
  },
  effects_UNSTABLE: [persistAtom],
});
